const config = require('../../config');
const createAction = require('redux-actions').createAction;
require('es6-promise');
require('isomorphic-fetch');

const getUrlParam = require('../../helper/dish-helper.js').getUrlParam;
const getSendCodeParamStr = require('../../helper/register-helper.js').getSendCodeParamStr;
const shopId = getUrlParam('shopId');

const setErrorMsg = (exports.setErrorMsg = createAction('SET_ERROR_MSG', error => error));
const setLoadingInfo = (exports.setLoadingInfo = createAction('SET_LOADING_INFO', info => info));
const setSupportInfo = createAction('SET_SUPPORT_INFO', info => info);
const setTimeStamp = createAction('SET_TIMESTAMP', timestamp => timestamp);
const setUserPhone = createAction('SET_USER_PHONE', phone => phone);
const setLoginInfo = createAction('SET_LOGIN_INFO', loginInfo => loginInfo);
const condition = ['fromShopHome', 'fromBrand=false', 'queryMarketSharePage'];

import { formatMessage } from '../../intl/helper';
import actionText2 from '../../intl/messages/action/part2';
import actionText1 from '../../intl/messages/action/part1';
import fetchHelper from '../../helper/fetch-helper';

const isInclude = returnUrlDecode => {
  return condition.find(item => returnUrlDecode.indexOf(item) > -1);
};

exports.fetchLoginPhone = () => (dispatch, getState) => {
  const loginPhone = localStorage.getItem('loginPhone');
  dispatch(setUserPhone(loginPhone));
};

exports.login = (info, successCallback) => (dispatch, getState) => {
  let fromBrand = 1;
  if (!shopId) {
    dispatch(setErrorMsg(formatMessage(actionText2.actionshopIdCannotBeNull)));
    return false;
  }

  const originReturnUrl = getUrlParam('returnUrl') || encodeURIComponent(`/brand/index${location.search}`);
  const returnUrlDecode = decodeURIComponent(originReturnUrl);
  const returnUrl = encodeURIComponent(returnUrlDecode);
  const returnUrlPath = returnUrlDecode.substring(0, returnUrlDecode.indexOf('?'));
  const contain = isInclude(returnUrlDecode);

  // 如果是从门店相关的页面跳转过来的
  // 那么，fromBrand 设置为 0
  const isFromShopPages = /dishBox|Dinner|queue|prepare/.test(returnUrlPath);

  // fromShopHome 表示从门店首页跳转过来
  // 需要将 fromBrand 设置为 0
  // 如果 url 中的 fromBrand 为 false，那么 fromBrand 为 0
  // 如果 url 中存在 queryMarketSharePage, 那么 fromBrand 为 0
  if (isFromShopPages || contain) {
    fromBrand = 0;
  }

  if (info.isWeixin) {
    location.href = `${config.userLoginWXURL}?shopId=${shopId}&returnUrl=${returnUrl}&fromBrand=${fromBrand}`;
    return false;
  }

  if (info.isAlipay) {
    location.href = `${config.userLoginAlipayURL}?shopId=${shopId}&returnUrl=${returnUrl}&fromBrand=${fromBrand}`;
    return false;
  }

  dispatch(setLoadingInfo({ ing: true, text: formatMessage(actionText2.actionsysInProcessing) }));
  const timestamp = getState().timestamp || new Date().getTime();
  const nationTelCode = sessionStorage.getItem('nationTelCode');
  const url = `${config.userLoginAPI}?shopId=${shopId}&nationTelCode=${nationTelCode}&mobile=${info.phoneNum}&code=${
    info.code
  }&timeStamp=${timestamp}&fromBrand=${fromBrand}&returnUrl=${returnUrl}`;
  return fetchHelper.get(url)
    .then((result = {}) => {
      dispatch(setLoadingInfo({ ing: false }));
      // 大数据埋点将获取customerId，为了防止未登录从而导致高频调用后端APi。再登录成功后，即删除这个缓存。
      sessionStorage.removeItem('alreadyInvokeCustomerIdAndError');
      // dispatch(setLoginInfo({ loginData: result.data, url: returnUrl }));
      dispatch(setLoginInfo({ loginData: result, url: result.returnUrl }));
      successCallback(result || {});
    })
    .catch((err = {}) => {
      dispatch(setErrorMsg(err.msg || formatMessage(actionText2.actionloginFailed)));
      dispatch(setLoadingInfo({ ing: false }));
      throw new Error(err);
    });
};

exports.fetchVerificationCode = (phoneNum, nationTelCode) => (dispatch, getState) => {
  const obj = Object.assign({}, { shopId, mobile: phoneNum, nationTelCode, timestamp: new Date().getTime() });
  const paramStr = getSendCodeParamStr(obj);
  const url = `${config.sendCodeAPI}?${paramStr}`;
  dispatch(setLoadingInfo({ ing: true, text: formatMessage(actionText2.actionSending) }));
  return fetchHelper.get(url, null, { enableDefaultResponseResolve: false })
    .then(response => {
      const result = response.data || {};
      dispatch(setLoadingInfo({ ing: false }));
      if (result.code === '200') {
        dispatch(setTimeStamp(result.data.timeStamp));
        localStorage.removeItem('loginPhone');
      } else {
        dispatch(setErrorMsg(result.msg));
        if (result.code === '10100') {
          localStorage.setItem('loginPhone', phoneNum);
          setTimeout(function() {
            location.reload(true);
          }, 1500);
        }
      }
    })
    .catch(err => {
      throw new Error(err);
    });
};

exports.fetchSupportInfo = () => (dispatch, getState) => {
  const url = `${config.getUserLoginSupportAPI}?shopId=${shopId}`;
  dispatch(setLoadingInfo({ ing: true, text: formatMessage(actionText1.actionLoading) }));
  return fetchHelper.get(url)
    .then(result => {
      dispatch(setLoadingInfo({ ing: false }));
      dispatch(setSupportInfo(result));
    })
    .catch((err = {}) => {
      dispatch(setLoadingInfo({ ing: false }));
      dispatch(setErrorMsg(err.msg));
      throw new Error(err);
    });
};



// WEBPACK FOOTER //
// ./src/action/user-login/user-login.js